import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { ManagerCardComponent } from './manager-card';
import { StateImagePipe } from '../../pipes/state-img.pipe';
import { TruncatePipe } from '../../pipes/truncate-text.pipe';

@NgModule({
  declarations: [
    ManagerCardComponent,
    StateImagePipe    ,
    TruncatePipe
  ],
    imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    ManagerCardComponent
  ]
})
export class ManagerCardComponentModule {}


// WEBPACK FOOTER //
// ./src/components/manager-card/manager-card.module.ts